import MessagingTabs from './messagingTabs.view';

export default MessagingTabs;
